module.exports = __webpack_public_path__ + "img/horizontal_7_1_8011.9554db43.png";